import { StoryblokImageSlider } from './StoryblokImageSlider'

import { createImageSlider } from './__mocks__/imageSlider'

export { createImageSlider }

// Re-export for backward compatibility
export const dummyImageSliderStoryblok = createImageSlider()

export default StoryblokImageSlider
